import styles from './MultipleModalAdditionalContent.module.scss'

export const MultipleModalAdditionalContent = () => {
  return (
    <span className={styles.root}>
      {
        'Изменение настроек диетического питания займет продолжительное время. Новые настройки вступят в силу в течении от нескольких минут до нескольких часов, в зависимости от количества заведений'
      }
    </span>
  )
}
